import { LoaderService } from './../../utilities/_services/loader.service';
import { responsecls } from '@utilitymodel/responsecls';
import { AuthenticationService } from '@utilityService/authentication.service';
import { AlertMessage } from './../../utilities/_helpers/alert.message';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginRequest } from '@utilitymodel/login.model';
import { LocalCacheService } from '@utilityService/local-cache.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginRequest: LoginRequest = {} as LoginRequest;
  loginForm: FormGroup;
  ForgotForm: FormGroup;
  toastId = 0;
  showforgot = false;
  pwdType: string = 'password'
  constructor(private router: Router, private fb: FormBuilder, private modal: NgbModal,
    private alert: AlertMessage, private authService: AuthenticationService,
    private local: LocalCacheService,private meta: Meta) {
    this.loginForm = this.fb.group({
     UserName: ['', Validators.required],
      // UserName: ['sakthi.e@digisme.in', Validators.required],
      Password: ['', Validators.required],
      // UserName: ['support@digi-sme.com', Validators.required],
      // Password: ['Digi&2024', Validators.required],
      RememberMe: [false]
    });
    this.ForgotForm = this.fb.group({
      UserName: ['', Validators.required]
    });
    this.local.removeLocalCache();

  }

  ngOnInit(): void {
    this.local.removeLocalCache();
    this.modal.dismissAll();
    // let output: any = this.authService.checkrememberMe();
    // if (!!output) {
    //   this.loginForm.patchValue(output);
    //   this.login();

    // }
    this.meta.updateTag({
      name: 'robots',
      content: 'noindex, nofollow'
    });

    this.meta.updateTag({
      name: 'googlebot',
      content: 'noindex, nofollow'
    });
  }

  login() {
    if (this.loginForm.invalid) {
      this.toastId = this.alert.errorNotifier('Please fill in the login details.', this.toastId)
      return;
    }
    this.loginRequest = Object.assign(this.loginRequest, this.loginForm.value)


    this.authService.login(this.loginRequest).subscribe((r: responsecls) => {
      if (r.IsSuccess) {
        if (this.loginForm.value.RememberMe) {
          this.authService.rememberMe(this.loginForm.value);
        }
        // r.StatusObject.UserData.Country != '1'? this.authService.sendCRMUpdateLogin() : console.log("...");
        localStorage.removeItem("PayPeriod");
        this.router.navigate(['/Digi/dashboard']);
      } else {
        this.toastId = this.alert.errorNotifier(r.StatusMessage, this.toastId);
      }
    }, e => {
      console.log(e)
      this.toastId = this.alert.errorNotifier("Unable to connect to the server.", this.toastId);
    });
  }

  ForgotType() {
    this.showforgot = false;
  }

  loginType() {
    this.showforgot = true;
  }

  Forgot() {
    if (this.ForgotForm.invalid) {
      this.toastId = this.alert.errorNotifier('Please fill Email/Mobile Number.', this.toastId)
      return;
    }
    this.loginRequest = Object.assign(this.loginRequest, this.ForgotForm.value);

    this.authService.ForgotPassword(this.loginRequest).subscribe((r: responsecls) => {
      if (r.IsSuccess) {
        this.toastId = this.alert.successNotifier(r.StatusMessage, this.toastId);
        this.showforgot = false;

      }
      else if(r.IsSuccess == false){
        this.toastId = this.alert.successNotifier('Success! Further instructions have been sent to your current email address/mobile number on our record', this.toastId);
        }
      else {
        this.toastId = this.alert.successNotifier('Success! Further instructions have been sent to your current email address/mobile number on our record', this.toastId);
      }
    }, e => {
      this.toastId = this.alert.errorNotifier("Unable to connect to the server.", this.toastId);
    });
  }

  navigatetoSME() {
    window.location.href = 'https://www.digi-sme.com/'
  }
}
